import React, { useState } from 'react';
import { SubscriptionFormProps } from '@magoosh/pages/payment_flows/types';
import StandaloneUserRegistrationForm from '@magoosh/pages/payment_flows/subscription_form/standalone_user_registration_form';
import FullRegistrationForm from '@magoosh/pages/payment_flows/subscription_form/full_registration_form';

const RegistrationForm: React.FC<SubscriptionFormProps> = (props) => {
  const [userFormData, setUserFormData] = useState(null);

  return (
    <div className="u-margin-T-m">
      {props.twoStepSignup &&
        (userFormData ? (
          <p>
            <a onClick={() => setUserFormData(null)}>Account</a> &gt;{' '}
            <span style={{ fontWeight: 'bold' }}>Payment</span>
          </p>
        ) : (
          <p>
            <span style={{ fontWeight: 'bold' }}>Account</span> &gt; <span>Payment</span>
          </p>
        ))}

      {props.twoStepSignup && !userFormData ? (
        <StandaloneUserRegistrationForm
          authenticityToken={props.authenticityToken}
          isEuUser={props.isEuUser}
          setUserFormData={setUserFormData}
        />
      ) : (
        <FullRegistrationForm {...props} user={userFormData} />
      )}
    </div>
  );
};

export default RegistrationForm;
